import { render, staticRenderFns } from "./Textarea1.vue?vue&type=template&id=5121879c&scoped=true&"
import script from "./Textarea1.vue?vue&type=script&lang=js&"
export * from "./Textarea1.vue?vue&type=script&lang=js&"
import style0 from "./Textarea1.vue?vue&type=style&index=0&id=5121879c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5121879c",
  null
  
)

export default component.exports